import { ErrorHandler, NgModule } from '@angular/core';
import { HttpClientModule, HTTP_INTERCEPTORS, HttpClient } from '@angular/common/http';
import { HttpInterceptorService } from './helpers/interceptor';
import { ToastrModule } from 'ngx-toastr';
import { DatePipe } from '@angular/common';
import { BrowserAnimationsModule } from '@angular/platform-browser/animations';
import { NgxUiLoaderModule, NgxUiLoaderRouterModule, NgxUiLoaderHttpModule, NgxUiLoaderConfig, POSITION, SPINNER } from 'ngx-ui-loader';
import { AppConfig } from './config/config';
import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './layout/app.component';
import { PrivateLayoutComponent } from './layout/private-layout/private-layout.component';
import { PublicLayoutComponent } from './layout/public-layout/public-layout.component';
import { HeaderComponent } from './components/header/header.component';
import { DashboardComponent } from './components/dashboard/dashboard.component';
import { SidenavComponent } from './components/sidenav/sidenav.component';
import { FormsModule } from '@angular/forms';
import { MultiSelectDropdownComponent } from './components/common/multi-select-dropdown/multi-select-dropdown.component';
import { PeriodPickerComponent } from './components/common/period-picker/period-picker.component';
import { ForgotPasswordComponent } from './components/forgot-password/forgot-password.component';
import { CrudComponent } from './components/crud/crud.component';
import { CrudTsComponent } from './components/crud/crud-ts/crud-ts.component';
import { UserManagementComponent } from './user-management/user-management.component';
import { AnalyticsOverviewComponent } from './components/dashboard/analytics-overview/analytics-overview.component';
import { OperationsAnalyticsComponent } from './components/dashboard/operations-analytics/operations-analytics.component';
import { SalesManagementComponent } from './components/dashboard/sales-management/sales-management.component';
import { NgChartsModule } from 'ng2-charts';
import { BarChartComponent } from './components/bar-chart/bar-chartcomponent';
import { DoughnutChartComponent } from './components/doughnut-chart/doughnut-chart.component';
import { LineChartComponent } from './components/line-chart/line-chart.component';
import { MapComponent } from './components/map/map.component';
import { GoogleMapsModule } from '@angular/google-maps';
import { UserProfileComponent } from './user/user-profile/user-profile.component';
import { UpdatePasswordComponent } from './user/update-password/update-password.component';
import { AddCustomerComponent } from './components/customers/add-customer/add-customer.component';
import { EditCustomerComponent } from './components/customers/edit-customer/edit-customer.component';
import { EditDynamicCustomerComponent } from './components/customers/edit-dynamic-customer/edit-dynamic-customer.component';
import { UploadCustomersComponent } from './components/customers/upload-customers/upload-customers.component';
import { ClickStopPropagation } from './directives/ClickStopPropagation';
import { CustomersLayoutComponent } from './components/customers/customers-layout/customers-layout.component';
import { CustomersComponent } from './components/customers/customers-list/customers.component';
import { DragAndDropDirective } from './directives/drag-and-drop.directive';
import { UpdateProfileComponent } from './user/update-profile/update-profile.component';
import { UsersLayoutComponent } from './user/users-layout/users-layout.component';
import { BuildingsLayoutComponent } from './components/buildings/buildings-layout/buildings-layout.component';
import { BuildingsComponent } from './components/buildings/buildings-list/buildings/buildings.component';
import { DynamicBuildingsComponent } from './components/dynamic-buildings/dynamic-buildings.component';
import { EditDynamicBuildingComponent } from './components/buildings/edit-dynamic-building/edit-dynamic-building.component';
import { BuildingFilterWindowComponent } from './components/dynamic-buildings/building-filter-window/building-filter-window.component';
import { DynamicCustomersComponent } from './components/customers/dynamic-customers/dynamic-customers.component';
import { CustomerFilterWindowComponent } from './components/customers/dynamic-customers/customer-filter-window/customer-filter-window.component';
import { CardAnalyticsComponent } from './components/card-analytics/card-analytics.component';
import { EditBuildingsComponent } from './components/buildings/edit-buildings/edit-buildings/edit-buildings.component';
import { ProgressBarAngularModule } from 'progress-bar-angular';
import { CrudF33Component } from './components/crud/crud-f33/crud-f33.component';
import { CrudSsComponent } from './components/crud/crud-ss/crud-ss.component';
import { CrudF11Component } from './components/crud/crud-f11/crud-f11.component';
import { CrudDtComponent } from './components/crud/crud-dt/crud-dt.component';
import { CrudAreaComponent } from './components/crud/crud-area/crud-area.component';
import { CrudRegionComponent } from './components/crud/crud-region/crud-region.component';
import { CrudTariffComponent } from './components/crud/crud-tariff/crud-tariff.component';
import { CrudMeterTypeComponent } from './components/crud/crud-meter-type/crud-meter-type.component';
import { AddBuildingComponent } from './components/buildings/add-building/add-building.component';
import { UploadComponent } from './components/upload/upload.component';
import { PolesComponent } from './components/poles/poles-list/poles/poles.component';
import { PolesLayoutComponent } from './components/poles/poles-layout/poles-layout.component';
import { EditPolesComponent } from './components/poles/edit-poles/edit-poles.component';
import { AddPoleComponent } from './components/poles/add-pole/add-pole.component';
import { BuildingMapComponent } from './components/building-map/building-map.component';
import { TransformersLayoutComponent } from './components/transformers/transformers-layout/transformers-layout.component';
import { TransformersComponent } from './components/transformers/transformers-list/transformers.component';
import { AddTransformerComponent } from './components/transformers/add-transformer/add-transformer.component';
import { EditTransformerComponent } from './components/transformers/edit-transformer/edit-transformer.component';
import { AuditLogComponent } from './components/audit-log/audit-log.component';
import { AuditTrailComponent } from './components/audit-trail/audit-trail.component';
import { MetersLayoutComponent } from './components/meters/meters-layout/meters-layout.component';
import { MetersListComponent } from './components/meters/meters-list/meters-list.component';
import { EditMeterComponent } from './components/meters/edit-meter/edit-meter.component';
import { AddMeterComponent } from './components/meters/add-meter/add-meter.component';
import { DashboardMultiSelectDropdownComponent } from './components/common/dashboard-multi-select-dropdown/dashboard-multi-select-dropdown.component';
import { CrudCustomerComponent } from './components/crud/crud-customer/crud-customer.component';
import { CrudAssetRatingComponent } from './components/crud/crud-asset-rating/crud-asset-rating.component';
import { CrudDtMeterTypeComponent } from './components/crud/crud-dt-meter-type/crud-dt-meter-type.component';
import { CrudAssetStatusComponent } from './components/crud/crud-asset-status/crud-asset-status.component';
import { HistoryComponent } from './components/history/history.component';
import { CustomerHistoryModalComponent } from './components/history/customer-history-modal/customer-history-modal.component';
import { SurveyLayoutComponent } from './components/survey/survey-layout/survey-layout.component';
import { SurveyComponent } from './components/survey/survey/survey.component';
import { AddSurveyComponent } from './components/survey/add-survey/add-survey.component';
import { SurveyDetailsComponent } from './components/survey/survey-details/survey-details.component';
import { InstallationLayoutComponent } from './components/installations/installation-layout/installation-layout.component';
import { InstallationsListComponent } from './components/installations/installations-list/installations-list.component';
import { AddInstallationComponent } from './components/installations/add-installation/add-installation.component';
import { AddDtInstallationComponent } from './components/installations/add-dt-installation/add-dt-installation.component';
import { InstallationDetailsComponent } from './components/installations/installation-details/installation-details.component';
import { DtMeterInstallationDetailsComponent } from './components/installations/dt-meter-installation-details/dt-meter-installation-details.component';
import { DtMeterInstallationInvoiceDetailsComponent } from './components/installations/dt-meter-installation-invoice-details/dt-meter-installation-invoice-details.component';
import { FilterChecklistComponent } from './components/common/filter-checklist/filter-checklist.component';
import { AuditReviewComponent } from './audit-review/audit-review.component';

import { EditOnboardCustomerComponent } from './components/customers/edit-onboard-customer/edit-onboard-customer.component';
import * as Sentry from '@sentry/angular-ivy';
import { RoleManagementComponent } from './role-management/role-management.component';
import { PermissionMenuComponent } from './role-management/permission-menu/permission-menu.component';
import { CreateRoleComponent } from './role-management/create-role/create-role.component';
import { BpsAdminDashboardComponent } from './components/bps_admin/bps-admin-dashboard/bps-admin-dashboard.component';
import { UtilityListComponent } from './components/bps_admin/utility-management/utility-list/utility-list.component';
import { UtilityLayoutComponent } from './components/bps_admin/utility-management/utility-layout/utility-layout.component';
import { AddUtilityComponent } from './components/bps_admin/utility-management/add-utility/add-utility.component';
import { ColorPickerModule } from 'ngx-color-picker';
import { UtilityDetailsComponent } from './components/bps_admin/utility-management/utility-details/utility-details.component';
import { UtilityDropdownComponent } from './components/bps_admin/utility-dropdown/utility-dropdown.component';
import { UtilityAssetAndCustomerEntitiesComponent } from './components/bps_admin/utility-asset-and-customer-entities/utility-asset-and-customer-entities.component';
import { BpsAdminJobHistoryComponent } from './components/bps_admin/bps-admin-job-history/bps-admin-job-history.component';
import { NgxImageZoomModule } from 'ngx-image-zoom';
import { RegisterComponent } from './components/kyc/register/register.component';
import { LandingComponent } from './components/kyc/landing/landing.component';
import { GeneratePaymentComponent } from './components/survey/generate-payment/generate-payment.component';
import { LoginHeaderComponent } from './components/kyc/login-header/login-header.component';
import { PasswordStrengthComponent } from './components/kyc/password-strength/password-strength.component';
import { LoginKycComponent } from './components/kyc/login-kyc/login-kyc.component';
import { DashboardKycComponent } from './components/kyc/dashboard-kyc/dashboard-kyc.component';
import { SetNewPasswordComponent } from './components/kyc/set-new-password/set-new-password.component';
import { SharedModule } from './_modules/shared/shared.module';
import { ReportsComponent } from './components/reports/reports.component';
import { ReportCustomersComponent } from './components/reports/report-customers/report-customers.component';
import { WorkOrdersComponent } from './components/work-orders/work-orders.component';
import { SiteVerificationListComponent } from './components/work-orders/site-verification/site-verification-list/site-verification-list.component';
import { SiteVerificationDetailsComponent } from './components/work-orders/site-verification/site-verification-details/site-verification-details.component';
import { KycDetailsComponent } from './components/customers/kyc-details/kyc-details.component';
import { MaintenanceListComponent } from './components/work-orders/maintenance/maintenance-list/maintenance-list.component';
import { NewWorkOrderComponent } from './components/work-orders/maintenance/new-work-order/new-work-order.component';
import { WorkOrdersLayoutComponent } from './components/work-orders/work-orders-layout/work-orders-layout.component';
import { WorkOrderDetailsComponent } from './components/work-orders/maintenance/work-order-details/work-order-details.component';
import { HistoryTrackerComponent } from './components/history-tracker/history-tracker.component';
import { CrudSltComponent } from './components/crud/crud-slt/crud-slt/crud-slt.component';
import { CrudMeterPriceComponent } from './components/crud/crud-meter-price/crud-meter-price.component';
import { DataQualityRejectionComponent } from './components/reports/data-quality-rejection/data-quality-rejection.component';
import { CustomersTabComponent } from './components/reports/data-quality-rejection/customers-tab/customers-tab.component';
import { BuildingsTabComponent } from './components/reports/data-quality-rejection/buildings-tab/buildings-tab.component';
import { LtPolesTabComponent } from './components/reports/data-quality-rejection/poles-tab/poles-tab.component';
import { TransformersTabComponent } from './components/reports/data-quality-rejection/transformers-tab/transformers-tab.component';
// import { AngularFireModule } from '@angular/fire/compat';
import { environment } from 'src/environments/environment';
// import { AngularFireAnalytics, AngularFireAnalyticsModule } from '@angular/fire/compat/analytics';
import { AdminLevelPipe } from './pipes/admin-level.pipe';
import { MeterStockInventory } from './components/meterManagement/meter-stock-inventory/meter-stock-inventory.component';
import { NewServiceComponent } from './components/new-service/new-service.component';
import { NewServiceDetailsComponent } from './components/new-service/new-service-details/new-service-details.component';
import { NewServiceLayoutComponent } from './components/new-service/new-service-layout/new-service-layout.component';
import { ServiceConnectionListComponent } from './components/work-orders/service-connection/service-connection-list/service-connection-list.component';
import { MeterStockUtilizationComponent } from './components/meterManagement/meter-stock-utilization/meter-stock-utilization.component';
import { MeterStockDecommissionedListComponent } from './components/meterManagement/meter-stock-decommissioned/meter-stock-decommissioned-list/meter-stock-decommissioned-list.component';
import { OptionsTooltipComponent } from './components/common/options-tooltip/options-tooltip.component';
import { ServiceConnectionDetailsComponent } from './components/work-orders/service-connection/service-connection-details/service-connection-details.component';
import { MeterStockDecommissionedDetailsComponent } from './components/meterManagement/meter-stock-decommissioned/meter-stock-decommissioned-details/meter-stock-decommissioned-details.component';
import { MeterStockDecommissionedLayoutComponent } from './components/meterManagement/meter-stock-decommissioned/meter-stock-decommissioned-layout/meter-stock-decommissioned-layout.component';
import { StockItemValuePipe } from './pipes/stock-item-value.pipe';
import { RegularizationComponent } from './components/reports/regularization/regularization.component';
import { CrudBillingAccountComponent } from './components/crud/crud-billing-account/crud-billing-account.component';
import { AddBillingAccountComponent } from './components/customers/add-billing-account/add-billing-account.component';
import { DataQualityComponent } from './components/data-quality/data-quality.component';
import { AuditReviewCustomerComponent } from './audit-review/audit-review-customer/audit-review-customer.component';
import { TranslateLoader, TranslateModule } from '@ngx-translate/core';
import { TranslateHttpLoader } from '@ngx-translate/http-loader';
import { ReadingsComponent } from './components/readings/readings.component';
import { ReadingsLayoutComponent } from './components/readings/readings-layout/readings-layout.component';
import { MeterReadingsListComponent } from './components/readings/meter-readings/meter-readings-list/meter-readings-list.component';
import { ReadingDetailsComponent } from './components/readings/meter-readings/reading-details/reading-details.component';
import { GetReadingStatusClassPipe } from './pipes/get-reading-status-class.pipe';
import { ReadingTextBoxComponent } from './components/readings/meter-readings/reading-details/reading-text-box/reading-text-box.component';
import { UtilityDropdownSingleComponent } from './components/bps_admin/utility-dropdown-single/utility-dropdown-single.component';
import { NetworkAssetOptionsDropdownComponent } from './components/common/network-asset-options-dropdown/network-asset-options-dropdown.component';
import { NetworkAssetsComponent } from './components/network-assets/network-assets.component';
import { CmAngularOrgChartModule } from 'cm-angular-org-chart';
import { SingleSelectDropdownComponent } from './components/common/single-select-dropdown/single-select-dropdown.component';
import { VflowChartComponent } from './components/common/vflow-chart/vflow-chart.component';
import { NetworkAssetsMoreOptionsComponent } from './components/network-assets/network-assets-more-options/network-assets-more-options.component';
import { SwitchButtonsComponent } from './components/switch-buttons/switch-buttons.component';
import { DuplicateEnumerationComponent } from './components/reports/duplicate-enumeration/duplicate-enumeration.component';
import { BcMapFullDetailsComponent } from './components/map/map-full-details/bc-map-full-details/bc-map-full-details.component';
import { DtMapFullDetailsComponent } from './components/map/map-full-details/dt-map-full-details/dt-map-full-details.component';
import { PoleMapFullDetailsComponent } from './components/map/map-full-details/pole-map-full-details/pole-map-full-details.component';
import { AdvancedMapComponent } from './components/advanced-map/advanced-map.component';
import { AdvSwitchButtonsComponent } from './components/switch-buttons/advanced-map-switch-buttons/adv-switch-buttons/adv-switch-buttons.component';
import { AdvancedMapPinComponent } from './components/advanced-map/advanced-map-pin/advanced-map-pin.component';
import { MapInfoWindowComponent } from './components/advanced-map/map-info-window/map-info-window.component';
import { ReviewComponent } from './components/review/review.component';
import { AdvancedMapFilterComponent } from './components/advanced-map/advanced-map-filter/advanced-map-filter.component';
import { DeploymentStatusPipe } from './pipes/deployment-status.pipe';
import { ImageSectionComponent } from './components/common/image-section/image-section.component';
import { EditRmuComponent } from './components/rmu/edit-rmu/edit-rmu.component';
import { RmusComponent } from './components/rmu/rmus/rmus.component';
import { RmuLayoutComponent } from './components/rmu/rmu-layout/rmu-layout.component';
import { InactivityWarningComponent } from './components/inactivity-warning/inactivity-warning.component';
import { Keepalive, NgIdleKeepaliveModule } from '@ng-idle/keepalive';
import { Idle } from '@ng-idle/core';
 import { AiImageUploadComponent } from './components/ai-image-upload/ai-image-upload.component';
import { MeterValidationLayoutComponent } from './components/meter-validation/meter-validation-layout/meter-validation-layout.component';
import { MeterValidationListPageComponent } from './components/meter-validation/meter-validation-list-page/meter-validation-list-page.component';
import { MeterValidationDetailsComponent } from './components/meter-validation/meter-validation-details/meter-validation-details.component';
import { MapSetupComponent } from './components/bps_admin/utility-management/map-setup/map-setup.component';
import { MeterValidationStatsCardComponent } from './components/common/meter-validation-stats-card/meter-validation-stats-card.component';
import { DashboardMeterValidationComponent } from './components/dashboard/dashboard-meter-validation/dashboard-meter-validation.component';
import { DropdownSearchComponent } from './components/common/dropdown-search/dropdown-search.component';
import { MvPolesComponent } from './components/mv-poles/mv-poles.component';
import { MvPolesLayoutComponent } from './components/mv-poles/mv-poles-layout/mv-poles-layout.component';
import { EditMvPolesComponent } from './components/mv-poles/edit-mv-poles/edit-mv-poles.component';
import { SearchMapComponentComponent } from './components/advanced-map/search-map-component/search-map-component.component';
import { SearchDropdownComponent } from './components/advanced-map/search-map-component/search-dropdown/search-dropdown.component';
import { SlideToggleDirective } from './directives/slidetoggle.directive';
import { DoughnutChartMapComponent } from './components/doughnut-chart-map/doughnut-chart-map.component';
import { GeneratedObjectRepresentationComponent } from './components/common/generated-object-representation/generated-object-representation.component';
import { OverviewLayoutComponent } from './components/ai-uav/overview/overview-layout.component';
import { BatchImageImportLayoutComponent } from './components/ai-uav/batch-image-import/batch-image-import-layout.component';
import { SegmentationListLayoutComponent } from './components/ai-uav/segmentation-list/segmentation-list-layout.component';
import { JobMonitoringLayoutComponent } from './components/ai-uav/job-monitoring/job-monitoring-layout.component';
import { InjectionSubstationLayoutComponent } from './components/injection-substation/injection-substation-layout.component';
import { NetworkStructureLayoutComponent } from './components/network-structure/network-structure-layout.component';
import { NetworkEntityClassesLayoutComponent } from './components/network-entity-classes/network-entity-classes-layout.component';
import { DataModelCustomizationLayoutComponent } from './components/data-model-customization/data-model-customization-layout.component';
import { AnalyticsLayoutComponent } from './components/analytics/analytics-layout.component';
import { SharedLibModule} from 'shared-lib';
import { SHARED_LIB_CONFIG } from 'shared-lib';
import { NewConnectionAndOnboarderListComponent } from './components/new-service/new-connection-and-onboarder-list/new-connection-and-onboarder-list.component';
import { ServiceOrderListComponent } from './components/new-service/service-order-list/service-order-list.component';
import { ServiceConnectionChargeListComponent } from './components/new-service/service-connection-charge-list/service-connection-charge-list.component';
import { ResetPasswordComponent } from './components/kyc/reset-password/reset-password.component';
import { GeolocationMapViewerComponent } from './components/geolocation-map-viewer/geolocation-map-viewer.component';
import { CookieConsentComponent } from './components/kyc/shared/cookie-consent/cookie-consent.component';
import { UserActivitySectionComponent } from './components/new-service/new-service-details/user-activity-section/user-activity-section.component';
import { MeterRequestSectionComponent } from './components/new-service/new-service-details/meter-request-section/meter-request-section.component';
import { CrudMeterModelComponent } from './components/crud/crud-meter-model/crud-meter-model.component';
import { OnboardedCustomerComponent } from './components/new-service/onboarded-customer/onboarded-customer.component';
import { CrudProjectDesignationComponent } from './components/crud/crud-project-designation/crud-project-designation.component';
import { PaymentHistoryListComponent } from './components/payment-history/payment-history-list/payment-history-list.component';
import { PaymentHistoryDetailsComponent } from './components/payment-history/payment-history-details/payment-history-details.component';
import { PaymentHistoryLayoutComponent } from './components/payment-history/payment-history-layout/payment-history-layout.component';
import { SettlementListComponent } from './components/payment-history/settlement-list/settlement-list.component';
import { SettlementDetailsComponent } from './components/payment-history/settlement-details/settlement-details.component';
import { CrudMeterAssignmentComponent } from './components/crud/crud-meter-assignment/crud-meter-assignment.component';
import { CrudMeterRepaymentComponent } from './components/crud/crud-meter-repayment/crud-meter-repayment.component';
import { CrudAssetMeterPriceComponent } from './components/crud/crud-asset-meter-price/crud-asset-meter-price.component';
import { ServiceRequestTrackerComponent } from './components/new-service/service-request-tracker/service-request-tracker.component';
import { MapSubstationSchemaDiagramComponent } from './components/advanced-map/map-substation-schema-diagram/map-substation-schema-diagram.component';
import { ServiceRequestTrackerDetailsComponent } from './components/new-service/service-request-tracker-details/service-request-tracker-details.component';
import { CrudMeterRatingComponent } from './components/crud/crud-meter-rating/crud-meter-rating.component';

const ngxUiLoaderConfig: NgxUiLoaderConfig = {
  bgsPosition: POSITION.centerCenter,
  bgsColor: 'var(--primary-color)',
  fgsColor: 'var(--primary-color)',
  overlayColor: 'transparent',
  bgsOpacity: 0.85,
  bgsSize: 70,
  fgsSize: 70,
  fgsType: SPINNER.rectangleBounce,
  bgsType: SPINNER.rectangleBounce,
};

export function HttpLoaderFactory(http: HttpClient) {
  return new TranslateHttpLoader(http, './assets/i18n/', '.json');
}
@NgModule({
  declarations: [
    AppComponent,
    PrivateLayoutComponent,
    PublicLayoutComponent,
    HeaderComponent,
    DashboardComponent,
    SidenavComponent,
    MultiSelectDropdownComponent,
    PeriodPickerComponent,
    ForgotPasswordComponent,
    AnalyticsOverviewComponent,
    OperationsAnalyticsComponent,
    SalesManagementComponent,
    BarChartComponent,
    DoughnutChartComponent,
    LineChartComponent,
    MapComponent,
    UserManagementComponent,
    RoleManagementComponent,
    CrudComponent,
    CrudTsComponent,
    UserProfileComponent,
    UpdatePasswordComponent,
    CustomersComponent,
    AddCustomerComponent,
    EditCustomerComponent,
    EditDynamicCustomerComponent,
    EditMeterComponent,
    UploadCustomersComponent,
    ClickStopPropagation,
    CustomersLayoutComponent,
    DragAndDropDirective,
    UpdateProfileComponent,
    UsersLayoutComponent,
    BuildingsLayoutComponent,
    BuildingsComponent,
    DynamicBuildingsComponent,
    EditDynamicBuildingComponent,
    BuildingFilterWindowComponent,
    DynamicCustomersComponent,
    CustomerFilterWindowComponent,
    CardAnalyticsComponent,
    EditBuildingsComponent,
    CrudF33Component,
    CrudSsComponent,
    CrudF11Component,
    CrudDtComponent,
    CrudAreaComponent,
    CrudRegionComponent,
    CrudTariffComponent,
    CrudMeterTypeComponent,
    EditBuildingsComponent,
    AddBuildingComponent,
    UploadComponent,
    PolesComponent,
    PolesLayoutComponent,
    EditPolesComponent,
    AddPoleComponent,
    BuildingMapComponent,
    TransformersLayoutComponent,
    TransformersComponent,
    AddTransformerComponent,
    EditTransformerComponent,
    AuditLogComponent,
    AuditTrailComponent,
    MetersLayoutComponent,
    MetersListComponent,
    AddMeterComponent,
    DashboardMultiSelectDropdownComponent,
    CrudAssetRatingComponent,
    CrudCustomerComponent,
    CrudDtMeterTypeComponent,
    CrudAssetStatusComponent,
    HistoryComponent,
    CustomerHistoryModalComponent,
    SurveyLayoutComponent,
    SurveyComponent,
    AddSurveyComponent,
    SurveyDetailsComponent,
    InstallationLayoutComponent,
    InstallationsListComponent,
    AddInstallationComponent,
    AddDtInstallationComponent,
    PermissionMenuComponent,
    CreateRoleComponent,
    InstallationDetailsComponent,
    DtMeterInstallationDetailsComponent,
    DtMeterInstallationInvoiceDetailsComponent,
    FilterChecklistComponent,
    DataQualityComponent,
    EditOnboardCustomerComponent,
    BpsAdminDashboardComponent,
    UtilityListComponent,
    UtilityLayoutComponent,
    AddUtilityComponent,
    UtilityDetailsComponent,
    UtilityDropdownComponent,
    UtilityAssetAndCustomerEntitiesComponent,
    FilterChecklistComponent,
    AuditReviewComponent,
    BpsAdminDashboardComponent,
    BpsAdminJobHistoryComponent,
    RegisterComponent,
    LandingComponent,
    GeneratePaymentComponent,
    LoginHeaderComponent,
    PasswordStrengthComponent,
    LoginKycComponent,
    DashboardKycComponent,
    ResetPasswordComponent,
    SetNewPasswordComponent,
    ReportsComponent,
    ReportCustomersComponent,
    WorkOrdersComponent,
    SiteVerificationListComponent,
    SiteVerificationDetailsComponent,
    KycDetailsComponent,
    MaintenanceListComponent,
    NewWorkOrderComponent,
    WorkOrdersLayoutComponent,
    WorkOrderDetailsComponent,
    HistoryTrackerComponent,
    CrudSltComponent,
    CrudMeterPriceComponent,
    DataQualityRejectionComponent,
    CustomersTabComponent,
    BuildingsTabComponent,
    LtPolesTabComponent,
    TransformersTabComponent,
    AdminLevelPipe,
    MeterStockInventory,
    MeterStockUtilizationComponent,
    NewServiceComponent,
    NewServiceDetailsComponent,
    NewServiceLayoutComponent,
    ServiceConnectionListComponent,
    MeterStockUtilizationComponent,
    MeterStockDecommissionedListComponent,
    OptionsTooltipComponent,
    ServiceConnectionDetailsComponent,
    MeterStockDecommissionedDetailsComponent,
    MeterStockDecommissionedLayoutComponent,
    StockItemValuePipe,
    RegularizationComponent,
    CrudBillingAccountComponent,
    AddBillingAccountComponent,
    AuditReviewCustomerComponent,
    ReadingsComponent,
    ReadingsLayoutComponent,
    MeterReadingsListComponent,
    ReadingDetailsComponent,
    GetReadingStatusClassPipe,
    ReadingTextBoxComponent,
    UtilityDropdownSingleComponent,
    NetworkAssetsComponent,
    NetworkAssetOptionsDropdownComponent,
    SingleSelectDropdownComponent,
    NetworkAssetsMoreOptionsComponent,
        SwitchButtonsComponent,
        DuplicateEnumerationComponent,
        BcMapFullDetailsComponent,
        DtMapFullDetailsComponent,
        PoleMapFullDetailsComponent,
        AdvancedMapComponent,
        AdvSwitchButtonsComponent,
        AdvancedMapPinComponent,
        ReviewComponent,
        DeploymentStatusPipe,
        ImageSectionComponent,
        AdvancedMapFilterComponent,
        RmusComponent,
        EditRmuComponent,
        RmuLayoutComponent,
        InactivityWarningComponent,
        AiImageUploadComponent,
        MeterValidationLayoutComponent,
        MeterValidationListPageComponent,
        MeterValidationDetailsComponent,
        MapSetupComponent,
        MeterValidationStatsCardComponent,
        DashboardMeterValidationComponent,
        DropdownSearchComponent,
        MvPolesComponent,
        MvPolesLayoutComponent,
        EditMvPolesComponent,
        SearchMapComponentComponent,
        SearchDropdownComponent,
        SlideToggleDirective,
        DoughnutChartMapComponent,
        GeneratedObjectRepresentationComponent,
        OverviewLayoutComponent,
        BatchImageImportLayoutComponent,
        SegmentationListLayoutComponent,
        JobMonitoringLayoutComponent,
        InjectionSubstationLayoutComponent,
        NetworkStructureLayoutComponent,
        NetworkEntityClassesLayoutComponent,
        DataModelCustomizationLayoutComponent,
    AnalyticsLayoutComponent,
    NewConnectionAndOnboarderListComponent,
    ServiceOrderListComponent,
    ServiceConnectionChargeListComponent,
    GeolocationMapViewerComponent,
    CookieConsentComponent,
    UserActivitySectionComponent,
    MeterRequestSectionComponent,
    CrudMeterModelComponent,
    OnboardedCustomerComponent,
    CrudProjectDesignationComponent,
    PaymentHistoryListComponent,
    PaymentHistoryDetailsComponent,
    PaymentHistoryLayoutComponent,
    SettlementListComponent,
    SettlementDetailsComponent,
    CrudMeterAssignmentComponent,
    CrudMeterRepaymentComponent,
    CrudAssetMeterPriceComponent,
    ServiceRequestTrackerComponent,
    MapSubstationSchemaDiagramComponent,
    ServiceRequestTrackerDetailsComponent,
    CrudMeterRatingComponent
  ],
  imports: [
    SharedLibModule,
    AppRoutingModule,
    FormsModule,
    HttpClientModule,
    BrowserAnimationsModule,
    ToastrModule.forRoot(),
    NgxUiLoaderModule.forRoot(ngxUiLoaderConfig),
    NgxUiLoaderRouterModule.forRoot({ showForeground: true }),
    NgxUiLoaderHttpModule.forRoot({exclude:[environment["pathApi"] +'customer/getStats', environment["pathApi"] +'Schematic/save', environment["pathApi"] +'Schematic/getBySubstationId', environment["pathApi"] +'chat/send', environment["pathApi"] +'chat/start'], showForeground: true}),
    NgChartsModule,
    GoogleMapsModule,
    ProgressBarAngularModule,
    ColorPickerModule,
    NgxImageZoomModule,
    SharedModule,
    TranslateModule.forRoot({
      loader: {
        provide: TranslateLoader,
        useFactory: HttpLoaderFactory,
        deps: [HttpClient],
      },
    }),
    CmAngularOrgChartModule,
    VflowChartComponent,
    MapInfoWindowComponent,
    NgIdleKeepaliveModule.forRoot(),
  ],
  providers: [
    AppConfig,
    DatePipe,
    {
      provide: HTTP_INTERCEPTORS,
      useClass: HttpInterceptorService,
      multi: true,
    },
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({
        showDialog: false,
      }),
    },
    Idle,
    Keepalive,
    {
      provide: SHARED_LIB_CONFIG,
      useValue: { pathApi: environment.pathApi }
    }
  ],
  bootstrap: [AppComponent],
})
export class AppModule {
  // constructor(private analytics: AngularFireAnalytics) {
  //   if (environment.production) {
  //     this.analytics.setAnalyticsCollectionEnabled(true);
  //   } else {
  //     this.analytics.setAnalyticsCollectionEnabled(false);
  //   }
  // }
}
